import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPWortenIcon = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Worten"
        data-name="Worten"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132.51 90.35"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Worten</title>
        <rect fill="#e32213" x="0" y="21.84" width="132.51" height="46.67" />
        <path
          fill="#fff"
          d="m23.48,53.79l-8.07-12.7c-.78-1.21-.4-2.82.81-3.57,1.21-.78,2.82-.4,3.57.81l3.66,5.79,3.66-5.79c.78-1.21,2.36-1.56,3.57-.81,1.21.78,1.56,2.36.81,3.57l-8.01,12.7Z"
        />
        <path
          fill="#fff"
          d="m35.2,53.79l-8.07-12.7c-.78-1.21-.4-2.82.81-3.57,1.21-.78,2.82-.4,3.57.81l3.66,5.79,3.66-5.79c.78-1.21,2.36-1.56,3.57-.81,1.21.78,1.56,2.36.81,3.57l-8.01,12.7Z"
        />
        <path
          fill="#fff"
          d="m52.2,36.91c-4.81,0-8.73,3.8-8.73,8.5s3.92,8.5,8.73,8.5,8.73-3.8,8.73-8.5-3.92-8.5-8.73-8.5Zm0,12.53c-2.02,0-3.69-1.84-3.69-4.09s1.64-4.09,3.69-4.09,3.69,1.84,3.69,4.09-1.64,4.09-3.69,4.09Z"
        />
        <path
          fill="#fff"
          d="m67.35,53.44h-5.19v-10.28c0-3.23,2.62-5.85,5.85-5.85h3.72v4.47h-3.57c-.37,0-.84.55-.84.92v10.74h.03Z"
        />
        <path
          fill="#fff"
          d="m78.01,48.17v-6.42h2.28c1.24,0,2.22-1.01,2.22-2.22s-1.01-2.22-2.22-2.22h-2.28v-2.22c0-1.27-1.04-2.3-2.48-2.3-1.33,0-2.36,1.12-2.36,2.48v13.31c0,2.71,2.19,4.9,4.9,4.9h4.44v-4.49h-3.69c-.43,0-.81-.37-.81-.81Z"
        />
        <path
          fill="#fff"
          d="m99.58,47.02c.12-.52.17-1.07.17-1.64,0-4.67-3.8-8.5-8.47-8.5s-8.47,3.8-8.47,8.5,3.8,8.5,8.47,8.5c3.6,0,6.71-2.28,7.92-5.47h-5.1c-.72.84-1.76,1.35-2.88,1.35-1.67,0-3.11-1.12-3.72-2.74h12.07Zm-8.35-5.99c1.5,0,2.79.89,3.46,2.22h-6.94c.69-1.33,1.99-2.22,3.49-2.22Z"
        />
        <path
          fill="#fff"
          d="m117.44,53.53h-5.01l-.03-8.12c0-1.04-.46-3.54-3.37-3.54-2.33,0-3.2,1.96-3.2,3.05v8.61h-4.95v-8.61c0-3.26,2.53-7.84,8.15-7.84s8.38,4.29,8.38,8.33v8.12h.03Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default MPWortenIcon;
